import {
  Box,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import type { Components } from 'react-markdown'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

const components: Components = {
  p: ({ children }) => (
    <Typography variant="body2" sx={{ mb: 0.75, lineHeight: 1.6, '&:last-child': { mb: 0 } }}>
      {children}
    </Typography>
  ),
  h1: ({ children }) => (
    <Typography variant="h6" fontWeight={700} sx={{ mt: 1.5, mb: 0.5 }}>
      {children}
    </Typography>
  ),
  h2: ({ children }) => (
    <Typography variant="subtitle1" fontWeight={700} sx={{ mt: 1.5, mb: 0.5 }}>
      {children}
    </Typography>
  ),
  h3: ({ children }) => (
    <Typography variant="subtitle2" fontWeight={700} sx={{ mt: 1, mb: 0.5 }}>
      {children}
    </Typography>
  ),
  strong: ({ children }) => <strong>{children}</strong>,
  em: ({ children }) => <em>{children}</em>,
  hr: () => <Divider sx={{ my: 1 }} />,
  ul: ({ children }) => (
    <Box component="ul" sx={{ pl: 2.5, my: 0.5, '& li': { mb: 0.25 } }}>
      {children}
    </Box>
  ),
  ol: ({ children }) => (
    <Box component="ol" sx={{ pl: 2.5, my: 0.5, '& li': { mb: 0.25 } }}>
      {children}
    </Box>
  ),
  li: ({ children }) => (
    <Typography component="li" variant="body2" sx={{ lineHeight: 1.6 }}>
      {children}
    </Typography>
  ),
  code: ({ children, className }) => {
    const isBlock = className?.startsWith('language-')
    return isBlock ? (
      <Box
        component="pre"
        sx={{
          my: 1,
          p: 1.25,
          borderRadius: 1,
          bgcolor: 'action.selected',
          overflowX: 'auto',
          fontSize: 12,
          fontFamily: 'monospace',
          lineHeight: 1.5,
        }}
      >
        <code>{children}</code>
      </Box>
    ) : (
      <Box
        component="code"
        sx={{
          px: 0.5,
          py: 0.1,
          borderRadius: 0.5,
          bgcolor: 'action.selected',
          fontSize: '0.8em',
          fontFamily: 'monospace',
        }}
      >
        {children}
      </Box>
    )
  },
  table: ({ children }) => (
    <Box sx={{ overflowX: 'auto', my: 1 }}>
      <Table size="small" sx={{ minWidth: 300 }}>
        {children}
      </Table>
    </Box>
  ),
  thead: ({ children }) => <TableHead>{children}</TableHead>,
  tbody: ({ children }) => <TableBody>{children}</TableBody>,
  tr: ({ children }) => <TableRow>{children}</TableRow>,
  th: ({ children }) => <TableCell sx={{ fontWeight: 700, fontSize: 12 }}>{children}</TableCell>,
  td: ({ children }) => <TableCell sx={{ fontSize: 12 }}>{children}</TableCell>,
}

type Props = {
  content: string
}

export const MarkdownContent = ({ content }: Props) => {
  console.log('content')
  return (
    <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
      {content}
    </ReactMarkdown>
  )
}
